import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight, Images } from "lucide-react";
import { api, galleryImageUrl } from "@/lib/api";
import Reveal from "@/components/Reveal";

export default function GalleryPreview() {
  const { data: images = [] } = useQuery({
    queryKey: ["gallery"],
    queryFn: async () => (await api.get("/gallery")).data,
  });

  if (images.length === 0) return null;
  const shown = images.slice(0, 6);

  return (
    <section className="relative py-24 sm:py-32 bg-sec-1">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-12">
          <div>
            <Reveal>
              <span className="text-xs font-bold tracking-[0.25em] uppercase text-chapel-red">Our Moments</span>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-3 font-heading font-extrabold text-white text-3xl sm:text-5xl tracking-tight">
                Winners Chapel Colchester
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <Link to="/gallery" className="inline-flex items-center gap-2 text-zinc-300 hover:text-chapel-red transition-colors font-medium">
              View full gallery <ArrowRight className="w-4 h-4" />
            </Link>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {shown.map((img, i) => (
            <Reveal key={img.id} delay={(i % 3) * 0.08}>
              <Link
                to="/gallery"
                data-testid={`home-gallery-${i}`}
                className={`group relative block overflow-hidden rounded-2xl glass p-1.5 ${i === 0 ? "md:row-span-2 md:col-span-1" : ""}`}
              >
                <img
                  src={galleryImageUrl(img.id)}
                  alt={img.caption || `Church moment ${i + 1}`}
                  loading="lazy"
                  className={`w-full object-cover rounded-xl transition-transform duration-500 group-hover:scale-105 ${i === 0 ? "md:h-full aspect-square md:aspect-auto" : "aspect-square"}`}
                />
                <div className="absolute inset-1.5 rounded-xl bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                  {img.caption && <p className="text-white text-sm font-semibold">{img.caption}</p>}
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-10 text-center sm:hidden">
            <Link to="/gallery" className="inline-flex items-center gap-2 bg-chapel-red hover:bg-chapel-glow text-white font-semibold rounded-full px-7 py-3.5 transition-all duration-300 red-glow">
              <Images className="w-4 h-4" /> View full gallery
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
